export default __webpack_public_path__ + "static/media/news-and-features.1d2111af.jpg";